import React from 'react';
import { observer } from 'mobx-react';
import classnames from 'classnames';

import { toDate } from 'shared/utilities';
import { DateType } from 'shared/types';

import { Store } from 'pages/calendar/store';
import { CalendarPageDaysCalendarItem } from 'pages/calendar/components/CalendarPageDaysCalendarItem';
import { CalendarPageCreatingPopout } from 'pages/calendar/components/CalendarPageCreatingPopout';

import './styles.scss';

type PropsType = {
    days: DateType[];
};

export const CalendarPageDaysAllDay = observer(function CalendarPageDaysAllDay({ days }: PropsType) {
    return (
        <div className='calendar-page-days-all-day'>
            <div className='calendar-page-days__time calendar-page-days__time--all-day'>∞</div>
            {days.map(day => {
                const calendarItems = Store.calendarItems.filter(calendarItem => {
                    return calendarItem.isAllDayEvent && toDate(calendarItem.startAt).isSame(day, 'day');
                });
                return (
                    <div
                        key={day.format('YYYY-MM-DD')}
                        className={classnames('calendar-page-days-all-day-cell', {
                            'calendar-page-days-all-day-cell--weekend': day.day() === 0 || day.day() === 6,
                        })}
                    >
                        <CalendarPageCreatingPopout date={day} className={'calendar-page-days-all-day-cell__overlay'} calendarItem={{ isAllDayEvent: true }} />
                        <div className='calendar-page-days-all-day-cell__inner'>
                            {calendarItems.map(calendarItem => (
                                <CalendarPageDaysCalendarItem key={calendarItem.id} calendarItem={calendarItem} />
                            ))}
                        </div>
                    </div>
                );
            })}
        </div>
    );
});
